import React from 'react';
import './Widgets.css';

function Widgets() {
    return (
        <div className="widgets">
          <iframe 
          title="myframe"
          width="230" height="315"
          src="https://www.youtube.com/embed/5qF_qbaWt3Q" 
          frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>  
        </div>
    )
}

export default Widgets;
